import React, { useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../actions/commonActions';
import { Modal, Button } from 'react-bootstrap';
import label from "../labels/common_en.json";
const SessionTimeOut = (props) => {
  const dispatch = useDispatch();

  const [ showModal, setShowModal ] = useState(false)

  let accessToken = useSelector(state => state.loginReducer.accessToken);
  const session = JSON.parse(sessionStorage.getItem("session"));

  const isLoggedIn = accessToken || (session && session.jwtResponse.token);

  const handleClose = () => {
      setShowModal(false);
      window.location.reload();
  }

  const handleOnIdle = event => {
      if(isLoggedIn) {
          dispatch(logout(props, false));
          setShowModal(true);
      }
  }

  const handleOnActive = event => {

  }

  const handleOnAction = event => {

  }

  const timeoutInMinutes = process.env.REACT_APP_INACTIVE_SESSION_TIMEOUT || 30

  const { reset } = useIdleTimer({
      timeout: 60 * 1000 * timeoutInMinutes,
      onIdle: handleOnIdle,
      onActive: handleOnActive,
      onAction: handleOnAction,
      debounce: 500
  })
  return (
    <Modal show={showModal} backdrop="static">
      <Modal.Header>
        <Modal.Title>
          {label.You_have_been_idle} {timeoutInMinutes} {label.minutes}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>{label.The_session_has_timed_out}</Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={handleClose}>
          {label.BUTTON_OK}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SessionTimeOut;
